import React from 'react'
import { withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react'

import './index.scss'
import { PrivacyBottomBannerModel } from './models/PrivacyBottomBanner.model'
import { PrivacyBottomBannerProps } from './types/PrivacyBottomBanner.types'

const PrivacyBottomBanner = (props: PrivacyBottomBannerProps) => {
  if(props?.fields){
  const model = new PrivacyBottomBannerModel(props)

  return (
    props?.fields && (
      <div className="privacy-bottom-banner text-module--center">
        <div className="privacy-bottom-title">
          <RichText field={model?.title} />
        </div>
        <div className="privacy-bottom-subtitle">
          <RichText field={model?.subtitle} />
        </div>
      </div>
    )
  )
    }
    else{
      return (<></>)
    }
}

export default withSitecoreContext()(PrivacyBottomBanner)
